import { cn } from '@/core/lib/utils';

interface EmptyStateProps {
  title: string;
  description?: string;
  className?: string;
}

/**
 * Atomic component for empty states
 */
export function EmptyState({ title, description, className }: EmptyStateProps) {
  return (
    <div className={cn("p-8 text-center", className)}>
      <p className="text-gray-500">{title}</p>
      {description && (
        <p className="text-sm text-gray-400 mt-2">
          {description}
        </p>
      )}
    </div>
  );
}